import React from 'react';

const CloseIcon = ({ width = 14, height = 14, color = '#9CA3AF', style = {} }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path d="M1 1L13 13M13 1L1 13" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default CloseIcon;
